<p-tabs scrollable value="0">
  <p-tablist>
    <p-tab value="0">Special Investment</p-tab>
    <p-tab value="1">CSI Engagement Milestone 2</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      <div class="dashboard">
        <div class="p-grid dashboard-grid">
          <div class="p-col-12 p-lg-12 pageheader">
            <div class="fl-right">
              <button
                type="button"
                pButton
                (click)="exportNoPayeeIDPaymentReport()"
                class="ui-button-primary excel-export">
                <span
                  >No Payee ID <br />
                  Ready for Payment Report
                  @if (excelLoadingNoPayeeID) {
                    <i class="fa fa-spinner fa-spin"></i>
                  }
                </span>
              </button>
            </div>
            <div class="fl-right export-btn-first">
              <button
                type="button"
                pButton
                (click)="exportReadyforPaymentReport()"
                class="ui-button-primary excel-export btn-excel-first">
                <span
                  >Ready for Payment Report
                  @if (excelLoadingReadyforPayment) {
                    <i class="fa fa-spinner fa-spin"></i>
                  }
                </span>
              </button>
            </div>
          </div>
          <div class="p-col-12 p-lg-12 mb30">
            @if (loading) {
              <div class="loading-indicator">
                <p-progressSpinner></p-progressSpinner>
              </div>
            }
            <div class="ui-g card">
              <div class="ui-g-12 ui-md-12 ui-lg-12 tbst">
                <p-table
                  #pa
                  [columns]="cols"
                  [scrollable]="true"
                  [style]="{ width: '100%' }"
                  [value]="downloadCSV"
                  selectionMode="single"
                  [loadingIcon]="loadingIcon"
                  [showLoader]="true"
                  [(selection)]="selectedItem"
                  [paginator]="true"
                  [rows]="24"
                  paginatorPosition="both">
                  <ng-template #header>
                    <tr>
                      <th [pSortableColumn]="'fileName'" class="collarge">
                        File Name <p-sortIcon [field]="'fileName'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'createdOn'" class="collarge">
                        File Created on (PST)
                        <p-sortIcon [field]="'createdOn'"></p-sortIcon>
                      </th>
                      <th class="colsmall" style="text-align: center">
                        Download CSV
                      </th>
                    </tr>
                    <tr></tr
                  ></ng-template>
                  <ng-template #body let-downloadCSV let-columns="columns">
                    <tr>
                      <td class="collarge">{{ downloadCSV.fileName }}</td>
                      <td class="collarge">{{ downloadCSV.createdOn }}</td>
                      <td class="colsmall text-center">
                        <button
                          (click)="downloadFile(downloadCSV)"
                          tooltipPosition="top"
                          pTooltip="{{ downloadCSV.fileName }}"
                          class="edit-button-link">
                          <i
                            class="fa fa-file-excel-o"
                            aria-hidden="true"
                            style="font-size: 16px"></i>
                        </button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-csi-engagement-milestone2></app-csi-engagement-milestone2>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
